import React, { useState, useEffect } from "react";
import "./Resume.css";
import { GrTwitter } from "react-icons/gr";
import { BsGithub } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";
import { BsLinkedin } from "react-icons/bs";
import { SiGeeksforgeeks } from "react-icons/si";
import Burger from "../Home/HOME/HamburgerMenu/Burger";
import BurgerBody from "../Home/HOME/BurgerBody/BurgerBody";
import AOS from "aos";
import "aos/dist/aos.css";
import ProgressBar from "./ProgressBar/ProgressBar";
import CountUp from 'react-countup';

const Resume = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const [visible, setVisible] = useState(true);

  const VisibleHandler = () => {
    if (!visible) setVisible(true);
    else setVisible(false);
  };

  return (
    <>
      <div className="hamburger">
        <Burger onVisibility={VisibleHandler} />
      </div>

      {/* Hamburger Body! */}
      {!visible && (
        <div className="hamburger_body">
          <BurgerBody />
        </div>
      )}

      <div className="resume_nav">
        <a
          data-aos="fade-right"
          data-aos-delay="1500"
          className="resume_navicons"
        >
          {" "}
          <GrTwitter />
        </a>
        <a
          data-aos="fade-right"
          data-aos-delay="1600"
          className="resume_navicons"
        >
          {" "}
          <BsGithub />
        </a>
        <a
          data-aos="fade-right"
          data-aos-delay="1700"
          className="resume_navicons"
        >
          {" "}
          <BsInstagram />
        </a>
        <a
          data-aos="fade-right"
          data-aos-delay="1800"
          className="resume_navicons"
        >
          {" "}
          <BsLinkedin />
        </a>
        <a
          data-aos="fade-right"
          data-aos-delay="1900"
          className="resume_navicons"
        >
          {" "}
          <SiGeeksforgeeks />
        </a>
      </div>
      <div className="resume_body">
        <div className="resume_">
          <div className="resume_intro">
            <div
              data-aos="zoom-in"
              data-aos-delay="300"
              className="resume_profile"
            ></div>
            <div
              data-aos="fade-left"
              data-aos-delay="900"
              className="resume_desc"
            >
              I'm a programmer, content-creator, and artist who just loves to
              build stuff. Currently, I'm pursuing B-tech from Dayananda Sagar
              College of Engineering, Bengaluru.
            </div>
          </div>
          <div data-aos="fade-up" data-aos-delay="900" className="r-details">
            <div>
              <div className="res_head">ABOUT</div>
              <div className="_info">
                <div className="_info_head">NAME</div>
                <nav>Rohan Kumar Pandey</nav>
              </div>
              <div className="_info">
                <div className="_info_head">EMAIL</div>
                <nav>rohanpandey749@gmail.com</nav>
              </div>
              <div className="_info">
                <div className="_info_head">PHONE NO.</div>
                <nav>+91-8210036627</nav>
              </div>
              <div className="_info">
                <div className="_info_head">LOCATION</div>
                <nav>Bengaluru, India</nav>
              </div>
            </div>

            <div className="r-skills">
              <div data-aos="fade-up" data-aos-delay="300" className="r-info">
                <div className="res_head">TECHNICAL SKILLS</div>
                <div className="_info">
                  <div className="_info_head">C/C++</div>
                  <nav>
                    <CountUp start={0} end={80} duration={10} useEasing={true}/>%
                  </nav>
                </div>
                <div className="_info">
                  <div className="_info_head">HTML/CSS</div>
                  <nav>
                  <CountUp start={0} end={85} duration={10.5} useEasing={true}/>%
                  </nav>
                </div>
                <div className="_info">
                  <div className="_info_head">JAVASCRIPT</div>
                  <nav>
                  <CountUp start={0} end={65} duration={9} useEasing={true}/>%
                  </nav>
                </div>
                <div className="_info">
                  <div className="_info_head">REACT</div>
                  <nav>
                  <CountUp start={0} end={70} duration={9.7} useEasing={true}/>%
                  </nav>
                </div>
                <div className="_info">
                  <div className="_info_head">CANVA</div>
                  <nav>
                    <CountUp start={0} end={80} duration={10} useEasing={true}/>%
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <a
            href="https://drive.google.com/file/d/1xyQQK6hRdaWSjonEpjcXOnpXt52jbMhy/view?usp=sharing"
            target="_blank"
            className="download_"
          >
            <button className="download_btn">Download Resume</button>
          </a>
        </div>
      </div>
    </>
  );
};

export default Resume;
